var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({staticClass:"mr-3",attrs:{"small":"","text":"","icon":"","dark":"","to":"balance"}},on),[_vm._v(" "+_vm._s(_vm.$t('balance.short'))+" ")])]}}])},[_vm._v(" "+_vm._s(_vm.$t('balance.menu'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }